export default __webpack_public_path__ + "static/media/arrow.7f98d041.svg";